export default {
  'tour.name': 'Tour name',
  'tour.en.name': 'Tour Name English',
  'tour.en.fa.name': 'Tour Name Persian',
  'tour.englishTourName': 'Tour Name ( in English )',
  'tour.persianTourName': 'Tour Name ( in Persian )',
  'tour.necessities': 'Necessities English',
  'tour.en.necessities': 'Necessities in English',
  'tour.en.fa.necessities': 'Necessities in Persian',
  'tour.englishNecessities': 'Essentials needed for travel (in English)',
  'tour.persianNecessities': 'Essentials needed for travel (in persian)',
  'tour.moneyUnit': 'Money Unit',
  'tour.price': 'Price',
  'tour.setPrice': 'Set Price',
  'tour.type': 'Tour Type',
  'tour.registerDate': 'Register Date',
  'tour.whether': 'Whether',
  'tour.tourCondition': 'Tour Condition',
  'tour.passengerTypes': 'passenger Types',
  'tour.choosePassengerTypes': 'Choose Passenger Types',
  'tour.capacity': 'Capacity of number of people in the tour',
  'tour.duration': 'Tour duration (days)',
  'tour.destination': 'Destination',
  'tour.destinationCity': 'Destination City',
  'tour.destinationCountry': 'Destination Country',
  'tour.en.destination': 'Destination Name English',
  'tour.en.fa.destination': 'Destination Name Persian',
  'tour.description': 'description',
  'tour.en.description': 'description in English',
  'tour.en.fa.description': 'description in Persian',
  'tour.englishDescription':
    'Mention details required for the trip (in English)',
  'tour.persianDescription':
    'Mention details required for the trip (in persian)',
  'tour.limitaions': 'Limitations',
  'tour.en.limitaions': 'Limitations in english',
  'tour.englishlimitaions': 'Travel Limitations (in English)',
  'tour.persianlimitaions': 'Travel Limitations (in persian)',
  'tour.departure': 'departure',
  'tour.departureCity': 'departure City',
  'tour.departureCountry': 'departure Country',
  'tour.en.departure': 'departure',
  'tour.en.fa.departure': 'departure in persian',
  'tour.difficultyRate': 'Travel difficulty',
  'tour.departureDate': 'Tour start time',
  'tour.international': 'international',
  'tour.domestic': 'domestic',
  'tour.addTour': 'Add a new tour',
  'tour.easy': 'Easy',
  'tour.amature': 'Amatur',
  'tour.normal': 'Normal',
  'tour.hard': 'Hard',
  'tour.veryHard': 'Very Hard',
  'tour.road': 'Road',
  'tour.flight': 'Flight',
  'tour.marine': 'Marine',
  'tour.transportTypes': 'Transport Types',
  'tour.chooseTransportTypes': 'Choose Transport Types',
  'tour.surpriseTour': 'Surprise Tour',
  'tour.ordinaryTour': 'Ordinary Tour',
  'tour.next': 'Next Step',
  'tour.home': 'Home',
  'tour.confirm': 'Confirm',
  'tour.previous': 'previous Step',
  'tour.active': 'Active',
  'tour.disable': 'Disable',
  'tour.dollar': 'US Dollar',
  'tour.euro': 'Euro',
  'tour.rial': 'Rial',
  'tour.stepOne': 'Step 1',
  'tour.stepTwo': 'Step 2',
  'tour.stepThree': 'Step 3',
  'tour.stepFour': 'Step 4',
  'tour.stepFive': 'Step 5',
  'tour.details': 'Details',
  'tour.tourDetails': 'Tour Details',
  'tour.cancel': 'Cancel',
  'tour.chooseTourType': 'Choose Tour Type',
  'tour.save': 'Save',
  'tour.tourDetail': 'Tour Information',
  'tour.furtherInformation': 'Further information',
  'tour.toddlerinownsitPrice': 'Price for a toddler in own sit',
  'tour.infantPrice': 'Price for a infant',
  'tour.childPrice': 'Price for a child',
  'tour.adultPrice': 'Price for a adult',
  'tour.studentPrice': 'Price for a student',
  'tour.seniorcitizenPrice': 'Price for a senior citizen',
  'tour.bookingDeadline': 'Deadline for Registration for the Tour',
  'tour.climateType': 'weather during the trip',
  'tour.step': 'Step',
  'tour.tourclimateTitle': 'Tour Climate Selection',
  'tour.tourclimateDescription': 'Choose the type of weather you want',
  'tour.tourtypeTitle': 'Tour Type Selection',
  'tour.tourtypeDescription': 'Select the type of tour you want',
  'tour.tourtransfertypeTitle': 'Tour Transport Type',
  'tour.tourtransfertypeDescription':
    'Select the type of tour transportation you want',
  'tour.tourpassengertypeTitle': 'Tour Passenger Type ',
  'tour.tourpassengertypeDescription':
    'Select the type of tour travelers you want',
  'tour.tourinformationTitle': 'Tour Information',
  'tour.tourinformationDescription': 'Enter your complete tour information',
  'tour.touroverviewTitle': 'Tour Overview',
  'tour.touroverviewDescription':
    'Review your tour information and edit as needed',
  'tour.tourpriceTitle': 'Tour Price',
  'tour.overview': 'overview ',
  'tour.tourpriceDescription': 'Enter prices for each passenger of your choice',
  'tour.tourScheduling': 'Tour Scheduling',
  'tour.mainTourInformation': 'Main tour information',
  'tour.tourConditions': 'Tour conditions',
  'tour.tourRestrictionsRequirements': 'Tour restrictions and requirements',
  'tour.tourRegistration': 'Tour Registration',
  'tour.addNewTour': 'Add a New Tour',
  'tour.name': 'Tour name',
  'tour.en.name': 'Tour Name English',
  'tour.en.fa.name': 'Tour Name Persian',
  'tour.englishTourName': 'Tour Name ( in English )',
  'tour.persianTourName': 'Tour Name ( in Persian )',
  'tour.necessities': 'Necessities English',
  'tour.en.necessities': 'Necessities in English',
  'tour.en.fa.necessities': 'Necessities in Persian',
  'tour.englishNecessities': 'Essentials needed for travel (in English)',
  'tour.persianNecessities': 'Essentials needed for travel (in persian)',
  'tour.moneyUnit': 'Money Unit',
  'tour.price': 'Price',
  'tour.setPrice': 'Set Price',
  'tour.type': 'Tour Type',
  'tour.registerDate': 'Register Date',
  'tour.whether': 'Whether',
  'tour.tourCondition': 'Tour Condition',
  'tour.passengerTypes': 'passenger Types',
  'tour.choosePassengerTypes': 'Choose Passenger Types',
  'tour.capacity': 'Capacity of number of people in the tour',
  'tour.duration': 'Tour duration (days)',
  'tour.destination': 'Destination',
  'tour.destinationCity': 'Destination City',
  'tour.destinationCountry': 'Destination Country',
  'tour.en.destination': 'Destination Name English',
  'tour.en.fa.destination': 'Destination Name Persian',
  'tour.description': 'description',
  'tour.en.description': 'description in English',
  'tour.en.fa.description': 'description in Persian',
  'tour.englishDescription':
    'Mention details required for the trip (in English)',
  'tour.persianDescription':
    'Mention details required for the trip (in persian)',
  'tour.limitaions': 'Limitations',
  'tour.en.limitaions': 'Limitations in english',
  'tour.englishlimitaions': 'Travel Limitations (in English)',
  'tour.persianlimitaions': 'Travel Limitations (in persian)',
  'tour.departure': 'departure',
  'tour.departureCity': 'departure City',
  'tour.departureCountry': 'departure Country',
  'tour.en.departure': 'departure',
  'tour.en.fa.departure': 'departure in persian',
  'tour.difficultyRate': 'Travel difficulty',
  'tour.departureDate': 'Tour start time',
  'tour.international': 'international',
  'tour.domestic': 'domestic',
  'tour.addTour': 'Add a new tour',
  'tour.easy': 'Easy',
  'tour.amature': 'Amatur',
  'tour.normal': 'Normal',
  'tour.hard': 'Hard',
  'tour.veryHard': 'Very Hard',
  'tour.road': 'Road',
  'tour.flight': 'Flight',
  'tour.marine': 'Marine',
  'tour.transportTypes': 'Transport Types',
  'tour.chooseTransportTypes': 'Choose Transport Types',
  'tour.surpriseTour': 'Surprise Tour',
  'tour.ordinaryTour': 'Ordinary Tour',
  'tour.next': 'Next Step',
  'tour.home': 'Home',
  'tour.confirm': 'Confirm',
  'tour.previous': 'previous Step',
  'tour.active': 'Active',
  'tour.disable': 'Disable',
  'tour.dollar': 'US Dollar',
  'tour.euro': 'Euro',
  'tour.rial': 'Rial',
  'tour.stepOne': 'Step 1',
  'tour.stepTwo': 'Step 2',
  'tour.stepThree': 'Step 3',
  'tour.stepFour': 'Step 4',
  'tour.stepFive': 'Step 5',
  'tour.details': 'Details',
  'tour.tourDetails': 'Tour Details',
  'tour.cancel': 'Cancel',
  'tour.chooseTourType': 'Choose Tour Type',
  'tour.save': 'Save',
  'tour.tourDetail': 'Tour Information',
  'tour.furtherInformation': 'Further information',
  'tour.toddlerinownsitPrice': 'Price for a toddler in own sit',
  'tour.infantPrice': 'Price for a infant',
  'tour.childPrice': 'Price for a child',
  'tour.adultPrice': 'Price for a adult',
  'tour.studentPrice': 'Price for a student',
  'tour.seniorcitizenPrice': 'Price for a senior citizen',
  'tour.bookingDeadline': 'Deadline for Registration for the Tour',
  'tour.climateType': 'weather during the trip',
  'tour.step': 'Step',
  'tour.tourclimateTitle': 'Tour Climate Selection',
  'tour.tourclimateDescription': 'Choose the type of weather you want',
  'tour.tourtypeTitle': 'Tour Type Selection',
  'tour.tourtypeDescription': 'Select the type of tour you want',
  'tour.tourtransfertypeTitle': 'Tour Transport Type',
  'tour.tourtransfertypeDescription':
    'Select the type of tour transportation you want',
  'tour.tourpassengertypeTitle': 'Tour Passenger Type ',
  'tour.tourpassengertypeDescription':
    'Select the type of tour travelers you want',
  'tour.tourinformationTitle': 'Tour Information',
  'tour.tourinformationDescription': 'Enter your complete tour information',
  'tour.touroverviewTitle': 'Tour Overview',
  'tour.touroverviewDescription':
    'Review your tour information and edit as needed',
  'tour.tourpriceTitle': 'Tour Price',
  'tour.overview': 'overview ',
  'tour.tourpriceDescription': 'Enter prices for each passenger of your choice',
  'tour.tourScheduling': 'Tour Scheduling',
  'tour.mainTourInformation': 'Main tour information',
  'tour.tourConditions': 'Tour conditions',
  'tour.tourRestrictionsRequirements': 'Tour restrictions and requirements',
  'tour.tourRegistration': 'Tour Registration',
  'tour.addNewTour': 'Add a New Tour',

  'tour.tourInformationTemporarilyRecorded':
    'Tour information has been temporarily recorded',
  'tour.yourTourSuccessfullyRegistered':
    'Your tour has been successfully registered',
  'tour.tourInformationTemporarilyRecorded':
    'Tour information has been temporarily recorded',
  'tour.yourTourSuccessfullyRegistered':
    'Your tour has been successfully registered',

  'tour.tourpassengertype': 'Passenger Type',
  'tour.tourtransfertype': 'Tour Transfer',
  'tour.tourType': 'Tour Type',
  'tour.nameen': 'Tour Name(in English)',
  'tour.namefa': 'Tour Name(in Persian)',
  'tour.bookingDeadLine': 'Deadline for Registration for the Tour',
  'tour.climateTypes': 'Tour Climate',
  'tour.limitationsen': 'Travel Limitations (in English)',
  'tour.limitationsfa': 'Travel Limitations(in Persian)',
  'tour.necessitiesen': 'Essentials needed for travel (in English)',
  'tour.necessitiesfa': 'Essentials needed for travel(in Persian)',
  'tour.descriptionen': 'Mention details required for the trip (in English)',
  'tour.descriptionfa': 'Mention details required for the trip(in Persian)',
  'tour.tourpassengertype': 'Passenger Type',
  'tour.tourtransfertype': 'Tour Transfer',
  'tour.tourType': 'Tour Type',
  'tour.nameen': 'Tour Name(in English)',
  'tour.namefa': 'Tour Name(in Persian)',
  'tour.bookingDeadLine': 'Deadline for Registration for the Tour',
  'tour.climateTypes': 'Tour Climate',
  'tour.limitationsen': 'Travel Limitations (in English)',
  'tour.limitationsfa': 'Travel Limitations(in Persian)',
  'tour.necessitiesen': 'Essentials needed for travel (in English)',
  'tour.necessitiesfa': 'Essentials needed for travel(in Persian)',
  'tour.descriptionen': 'Mention details required for the trip (in English)',
  'tour.descriptionfa': 'Mention details required for the trip(in Persian)',

  'tour.editTourTransferType': 'Edit tour transfer information',
  'tour.editTourPassengerType':
    'Edit passenger information and prices for each passenger',
  'tour.editTourInformation': 'Edit general tour information',
  'tour.tourRegistration': 'Tour Registration',
  'tour.isActive': 'Activity',
  'tour.editTourPassengerType': 'Edit Tour Passenger Type',
  'tour.editTourTransferType': 'Edit Tour Transfer Type',
  'tour.editTourInformationType': 'Edit Tour Information',
  'tour.editTourPrice': 'Edit Passenger Price',
  'tour.attachments': 'Attachments',
  'tour.cancelingRules': 'Canceling Rules',
  'tour.editTourTransferType': 'Edit tour transfer information',
  'tour.editTourPassengerType':
    'Edit passenger information and prices for each passenger',
  'tour.editTourInformation': 'Edit general tour information',
  'tour.tourRegistration': 'Tour Registration',
  'tour.isActive': 'Activity',
  'tour.editTourPassengerType': 'Edit Tour Passenger Type',
  'tour.editTourTransferType': 'Edit Tour Transfer Type',
  'tour.editTourInformationType': 'Edit Tour Information',
  'tour.editTourPrice': 'Edit Passenger Price',
  'tour.attachments': 'Attachments',
  'tour.cancelingRules': 'Canceling Rules',

  'tour.endBookingDeadLine': 'End Booking Dead Line',
  'tour.endPrice': 'End Price',
  'tour.startPrice': 'Start Price',
  'tour.endDuration': 'End Duration',
  'tour.startDuration': 'Start Duration',
  'tour.endDepartureDate': 'End Departure Date',
  'tour.startDepartureDate': 'Start Departure Date',
  'tour.tour': 'tour',
  'tour.sortby': 'sort by',
  'tour.search': 'Search',
  'tour.nameoftour': 'Name of the tour ...',
  'tour.price': 'Price',
  'tour.type': 'Type',
  'tour.selectdate': 'Select date of tour',
  'tour.newest': 'Newest',
  'tour.cheapest': 'Cheapest',
  'tour.lowestduration': 'Lowest Duration',
  'tour.highestduration': 'Highest Duration',
  'tour.all': 'All',
  'tour.more': 'More Details',
  'tour.irr': 'IRR',
  'tour.usd': 'USD',
  'tour.tourfound': 'Tours found',
  'tour.origin': 'From',
  'tour.agerange': 'Age Range',
  'tour.date': 'Date',
  'tour.operator': 'Operator',
  'tour.necessities': 'Necessities',
  'tour.reserve': 'Reserve tour',
  'tour.amazingtour': 'Amazing Tour',
  'tour.tourfrom': 'َTour from ',
  'tour.difficultyrate': '(Difficulty rate)',
  'tour.measure': 'Submit Filter',
  'tour.domesticName': 'tour domestic name',
  'tour.count': 'number of people',
  'tour.originterminal': 'origin terminal',
  'tour.destinationterminal': 'destination terminal',
  'tour.vehicletype': 'Vehicle Type',
  'tour.starttime': 'Start Time',
  'tour.endtime': 'End Time',
  'tour.invalidreturndate': 'End date smaller than start date',
  'tour.invalidstartdate': 'Start date greater than end date',
  'tour.facilities': 'Tour facilities',
  'tour.invalidEndTime': 'End time less than start time',
  'tour.drafts': 'drafts',
  'tour.useprevioustours': 'using previous tours',
  'tour.Draft': 'Draft tours',
  'tour.creationDate': 'Creation date',
  'tour.dateCreatedFrom': 'Date created from',
  'tour.dateCreatedUntil': 'Date created until',
  'tour.ordering': 'Ordering',
  'tour.basedTourName': 'Based on tour name',
  'tour.basedNamePlace': 'Based on the name of the place',
  'tour.search': 'Search by name and location',
  'tour.facilitynotdeclared': 'facility is not declared',
  'tour.basicinfonotfound': 'tour information is not specified',
  'tour.finaldestination': 'final destination',
  'tour.insertdraft': 'insert draft',
  'tour.updatetdraft': 'update draft',
  'tour.ageSuffering': 'Age suffering',
  'tour.finaldestination': 'final destination',
  'tour.insertsuccess': 'The tour was successfully registered',
  'tour.draftinsertsuccess': 'The tour draft was successfully registered',
  'tour.inserterror': 'The tour registration was unsuccessful',
  'tour.updatesuccess': 'The tour was successfully updated',
  'tour.draftupdatesuccess': 'The tour draft was successfully updated',
  'tour.updateerror': 'The tour update was unsuccessful',
  'tour.deletesuccess': 'The tour was successfully deleted',
  'tour.draftdeletesuccess': 'The tour draft was successfully deleted',
  'tour.deleteerror': 'The tour delete was unsuccessful',
  'tour.deletedrafttour': 'delete the draft tour',
  'tour.deletedrafttourmessage':
    'Are you sure you want to delete the draft tour?',
  'tour.male': 'male',
  'tour.female': 'female',
  'tour.all': 'all',
  'tour.changefieldwarning':
    'If changes are made in the important fields, the information of the next steps will be deleted. Click for more information',
  'tour.importantfieldsintroduction':
    'apply changes to following fields will cause data lost of next forms',
  'tour.tournotspecified': 'tour information is not specified',
  'tour.stoptype': 'stop type',
  'tour.searchfacilities': 'Search facilities',
  'tour.confirmdata': 'All registered information is verified',
  'tour.vehiclenamefa': 'local vehicle name',
  'tour.vehiclenameen': 'english vehicle name',
  'tour.transportproviderlocal': 'transport Provider local name',
  'tour.transportprovideren': 'transport Provider english name',
  'tour.addnewtourtype': 'Add new tour type',
  'tour.submittourtype': 'submit new tour type',
  'tour.tourtypenamefa': 'Farsi name of tour type',
  'tour.tourtypenameen': 'English name of tour type',
  'tour.tourtypeinsertsuccess': 'insert succeed',
  'tour.tourtypeinserterror': 'insert unsuccessful',
  'tour.originairport': 'origin airport',
  'tour.destinationairport': 'destination airport',
  'tour.arrivaldateto': 'arrival date ',
  'tour.arrivaltimeto': 'arrival time ',
  'tour.nextmovedate': 'next transporting start date',
  'tour.nextmovetime': 'next transporting start time',
  'tour.tourimages': 'tour images',
  'tour.viewimages': 'view images',
  'tour.addnewtourfacility': 'Adding new tour facilities',
  'tour.tourfacilitynamefa': 'Farsi name of tour facilities',
  'tour.tourfacilitynameen': 'English name of tour facilities',
  'tour.originterminalfa': 'Local name of the originating terminal',
  'tour.originterminalen': 'English name of the originating terminal',
  'tour.destinationterminalfa': 'Local name of destination terminal',
  'tour.destinationterminalen': 'English name of destination terminal',
  'tour.underreviewing': 'under reviewing',
  'tour.expired': 'expired',
  'tour.residence': 'residence',
  'tour.pricepercustomer': 'price per person',
  'tour.userstours': 'my tours',
  'tour.usersalltours': 'all tours',
  'tour.usersactivetours': 'active tours',
  'tour.usersexpiredtours': 'expired tours',
  'tour.changerequiredfields': 'show operator review result',
  'tour.requiredreviews': 'required reviews',
  'tour.rejectionreason': 'rejection reason',
  'tour.rejectiondescription': 'rejection description',
  'tour.starttime': 'Start time',
  'tour.endtime': 'End time',
  'tour.imageuploadfailed': 'Image upload failed',
};
